// Persisted across a sign-in round-trip. A QR-scanned `/join/{code}`
// route stores the code here when the visitor needs to log in first,
// and app-index routes back to /join/{code} once auth resolves.
//
// Cleared by the join page itself once it has finished — either the
// user joined, was already a member, or dismissed the page.

const KEY = 'easypos-pending-join-code';

export function getPendingJoinCode(): string | null {
  try {
    const v = localStorage.getItem(KEY);
    return v && v.trim().length > 0 ? v.trim() : null;
  } catch {
    return null;
  }
}

export function setPendingJoinCode(code: string): void {
  try {
    localStorage.setItem(KEY, code.trim());
  } catch {
    /* ignore */
  }
}

export function clearPendingJoinCode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
